(function () {
  var cartInvoiceApplySeq = 0;

  var CLEAR_ATTRIBUTES = {
    corporate_invoice: 'false',
    invoice_entity_type: '',
    invoice_company: '',
    invoice_tax_office: '',
    invoice_tax_number: '',
    invoice_address_title: '',
    invoice_province: '',
    invoice_district: '',
    invoice_neighborhood: '',
    invoice_address: '',
  };

  function getI18n() {
    var node = document.querySelector('[data-cart-invoice-i18n]');
    if (!node) {
      return {};
    }
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      return {};
    }
  }

  function getModal(root) {
    return root ? root.querySelector('[data-cart-invoice-modal]') : null;
  }

  function digitsOnly(value) {
    return String(value || '').replace(/\s/g, '');
  }

  function isRepeatedDigits(value) {
    if (!value) {
      return false;
    }
    return value.split('').every(function (digit) {
      return digit === value[0];
    });
  }

  function isValidVkn(value) {
    var vkn = digitsOnly(value);
    if (!/^[0-9]{10}$/.test(vkn) || isRepeatedDigits(vkn)) {
      return false;
    }
    var v = vkn.split('').map(Number);
    var sum = 0;
    var i = 0;
    for (i = 0; i < 9; i += 1) {
      var tmp = (v[i] + (9 - i)) % 10;
      if (tmp === 0) {
        continue;
      }
      var product = (tmp * Math.pow(2, 9 - i)) % 9;
      if (product === 0) {
        product = 9;
      }
      sum += product;
    }
    var check = (10 - (sum % 10)) % 10;
    return v[9] === check;
  }

  function isValidTckn(value) {
    var tckn = digitsOnly(value);
    if (!/^[1-9][0-9]{10}$/.test(tckn) || isRepeatedDigits(tckn)) {
      return false;
    }
    var d = tckn.split('').map(Number);
    var odd = d[0] + d[2] + d[4] + d[6] + d[8];
    var even = d[1] + d[3] + d[5] + d[7];
    var digit10 = (odd * 7 - even) % 10;
    if (digit10 < 0) {
      digit10 += 10;
    }
    if (digit10 !== d[9]) {
      return false;
    }
    var sum10 = 0;
    var j = 0;
    for (j = 0; j < 10; j += 1) {
      sum10 += d[j];
    }
    return sum10 % 10 === d[10];
  }

  function getApiBase(root) {
    return String(root.getAttribute('data-cart-invoice-api') || '')
      .trim()
      .replace(/\/$/, '');
  }

  function getShop(root) {
    if (typeof window.jokerStorefrontShop === 'function') {
      return window.jokerStorefrontShop(root.getAttribute('data-cart-invoice-shop'));
    }
    return String(root.getAttribute('data-cart-invoice-shop') || '').trim().toLowerCase();
  }

  function getEntityType(modal) {
    var select = modal.querySelector('[data-cart-invoice-entity-select]');
    if (select && select.value === 'INDIVIDUAL') {
      return 'INDIVIDUAL';
    }
    return modal.getAttribute('data-cart-invoice-entity-type') === 'INDIVIDUAL' ? 'INDIVIDUAL' : 'COMPANY';
  }

  function setEntityType(modal, entityType) {
    var next = entityType === 'INDIVIDUAL' ? 'INDIVIDUAL' : 'COMPANY';
    modal.setAttribute('data-cart-invoice-entity-type', next);
    var select = modal.querySelector('[data-cart-invoice-entity-select]');
    if (select) {
      select.value = next;
    }
    modal.querySelectorAll('[data-cart-invoice-panel]').forEach(function (panel) {
      var show = panel.getAttribute('data-cart-invoice-panel') === next;
      if (show) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
    modal.querySelectorAll('[data-cart-invoice-tax-id-wrap]').forEach(function (wrap) {
      var show = wrap.getAttribute('data-cart-invoice-tax-id-wrap') === next;
      if (show) {
        wrap.removeAttribute('hidden');
      } else {
        wrap.setAttribute('hidden', '');
      }
    });
  }

  function isLoggedIn(root) {
    return Boolean(root.getAttribute('data-cart-invoice-customer-id'));
  }

  function redirectToLogin(root) {
    var url = root.getAttribute('data-cart-invoice-login-url') || '/account/login';
    window.location.href = url;
  }

  function fieldValue(modal, name) {
    var input = modal.querySelector('[data-cart-invoice-field="' + name + '"]');
    if (!input) {
      return '';
    }
    return String(input.value || '').trim();
  }

  function setFieldValue(modal, name, value) {
    var input = modal.querySelector('[data-cart-invoice-field="' + name + '"]');
    if (input) {
      input.value = value || '';
    }
  }

  function clearFieldErrors(modal) {
    modal.querySelectorAll('[data-cart-invoice-error]').forEach(function (node) {
      node.hidden = true;
      node.textContent = '';
    });
    modal.querySelectorAll('.cart-invoice__input.is-invalid, .cart-invoice__select.is-invalid, .cart-invoice__textarea.is-invalid').forEach(function (el) {
      el.classList.remove('is-invalid');
    });
  }

  function setFieldError(modal, name, message) {
    var errorEl = modal.querySelector('[data-cart-invoice-error="' + name + '"]');
    var input = modal.querySelector('[data-cart-invoice-field="' + name + '"]');
    if (errorEl) {
      errorEl.hidden = false;
      errorEl.textContent = message;
    }
    if (input) {
      input.classList.add('is-invalid');
    }
  }

  function showFeedback(root, message, isSuccess) {
    var node = root.querySelector('[data-cart-invoice-feedback]');
    if (!node) {
      return;
    }
    if (!message) {
      node.hidden = true;
      node.textContent = '';
      node.classList.remove('is-success');
      return;
    }
    node.hidden = false;
    node.textContent = message;
    node.classList.toggle('is-success', Boolean(isSuccess));
  }

  function showModalFeedback(modal, message, isSuccess) {
    var node = modal.querySelector('[data-cart-invoice-modal-feedback]');
    if (!node) {
      return;
    }
    if (!message) {
      node.hidden = true;
      node.textContent = '';
      node.classList.remove('is-success', 'is-pending');
      return;
    }
    node.hidden = false;
    node.textContent = message;
    node.classList.toggle('is-success', Boolean(isSuccess));
    node.classList.toggle('is-pending', isSuccess === 'pending');
  }

  function setModalSavePending(modal, pending, i18n) {
    var saveBtn = modal.querySelector('[data-cart-invoice-modal-save]');
    var cancelBtn = modal.querySelector('.cart-invoice-modal__cancel');
    var closeBtn = modal.querySelector('.cart-invoice-modal__close');
    if (saveBtn) {
      if (pending) {
        if (!saveBtn.dataset.cartInvoiceSaveLabel) {
          saveBtn.dataset.cartInvoiceSaveLabel = saveBtn.textContent || '';
        }
        saveBtn.disabled = true;
        saveBtn.textContent = i18n.modal_saving || '';
        saveBtn.setAttribute('aria-busy', 'true');
      } else {
        saveBtn.disabled = false;
        saveBtn.removeAttribute('aria-busy');
        if (saveBtn.dataset.cartInvoiceSaveLabel) {
          saveBtn.textContent = saveBtn.dataset.cartInvoiceSaveLabel;
        }
      }
    }
    if (cancelBtn) {
      cancelBtn.disabled = pending;
    }
    if (closeBtn) {
      closeBtn.disabled = pending;
    }
    if (pending) {
      showModalFeedback(modal, '', false);
    }
  }

  function collectForm(modal) {
    var entityType = getEntityType(modal);
    return {
      entityType: entityType,
      addressTitle: fieldValue(modal, 'addressTitle'),
      province: fieldValue(modal, 'province'),
      district: fieldValue(modal, 'district'),
      neighborhood: fieldValue(modal, 'neighborhood'),
      addressLine: fieldValue(modal, 'addressLine'),
      taxOffice: fieldValue(modal, 'taxOffice'),
      companyName: fieldValue(modal, 'companyName'),
      fullName: fieldValue(modal, 'fullName'),
      vkn: digitsOnly(fieldValue(modal, 'vkn')),
      tckn: digitsOnly(fieldValue(modal, 'tckn')),
    };
  }

  function validateForm(modal, i18n) {
    clearFieldErrors(modal);
    var fields = collectForm(modal);
    var entityType = fields.entityType;
    var valid = true;
    var requiredMsg = i18n.required || '';

    function fail(name, message) {
      valid = false;
      setFieldError(modal, name, message);
    }

    if (!fields.addressTitle) {
      fail('addressTitle', requiredMsg);
    }
    if (!fields.taxOffice) {
      fail('taxOffice', requiredMsg);
    }
    if (!fields.province) {
      fail('province', requiredMsg);
    }
    if (!fields.district) {
      fail('district', requiredMsg);
    }
    if (!fields.neighborhood) {
      fail('neighborhood', requiredMsg);
    }
    if (!fields.addressLine) {
      fail('addressLine', requiredMsg);
    }

    if (entityType === 'COMPANY') {
      if (!fields.companyName) {
        fail('companyName', requiredMsg);
      }
      if (!fields.vkn) {
        fail('vkn', requiredMsg);
      } else if (!isValidVkn(fields.vkn)) {
        fail('vkn', i18n.vkn_invalid || requiredMsg);
      }
    } else {
      if (!fields.fullName) {
        fail('fullName', requiredMsg);
      }
      if (!fields.tckn) {
        fail('tckn', requiredMsg);
      } else if (!isValidTckn(fields.tckn)) {
        fail('tckn', i18n.tckn_invalid || requiredMsg);
      }
    }

    return valid;
  }

  function profileToFields(profile) {
    var entityType = profile.entityType === 'INDIVIDUAL' ? 'INDIVIDUAL' : 'COMPANY';
    return {
      entityType: entityType,
      addressTitle: profile.addressTitle || '',
      province: profile.province || '',
      district: profile.district || '',
      neighborhood: profile.neighborhood || '',
      addressLine: profile.addressLine || '',
      taxOffice: profile.taxOffice || '',
      companyName: profile.companyName || '',
      fullName: profile.fullName || '',
      vkn: digitsOnly(profile.vkn || ''),
      tckn: digitsOnly(profile.tckn || ''),
    };
  }

  function fieldsToAttributes(fields) {
    var entityType = fields.entityType === 'INDIVIDUAL' ? 'INDIVIDUAL' : 'COMPANY';
    var taxNumber = entityType === 'COMPANY' ? fields.vkn : fields.tckn;
    var companyLine = entityType === 'COMPANY' ? fields.companyName : fields.fullName;
    return {
      corporate_invoice: 'true',
      invoice_entity_type: entityType,
      invoice_company: companyLine,
      invoice_tax_office: fields.taxOffice,
      invoice_tax_number: digitsOnly(taxNumber),
      invoice_address_title: fields.addressTitle,
      invoice_province: fields.province,
      invoice_district: fields.district,
      invoice_neighborhood: fields.neighborhood,
      invoice_address: fields.addressLine,
    };
  }

  function postCartAttributes(attributes) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ attributes: attributes }),
    }).then(function (response) {
      return response.json().then(function (json) {
        if (!response.ok) {
          throw new Error(json.description || json.message || 'Cart update failed');
        }
        return json;
      });
    });
  }

  function setCartReady(root, ready) {
    root.setAttribute('data-cart-invoice-cart-ready', ready ? 'true' : 'false');
  }

  function isCartReady(root) {
    return root.getAttribute('data-cart-invoice-cart-ready') === 'true';
  }

  function clearCorporateInvoice(root, i18n) {
    showFeedback(root, '', false);
    setCartReady(root, false);
    clearUserProfileChoice(root);
    return postCartAttributes(CLEAR_ATTRIBUTES)
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      })
      .catch(function () {
        showFeedback(root, i18n.save_error || '', false);
      });
  }

  function applyFieldsToCart(root, fields, i18n) {
    cartInvoiceApplySeq += 1;
    var applySeq = cartInvoiceApplySeq;
    return postCartAttributes(fieldsToAttributes(fields))
      .then(function (cart) {
        if (applySeq !== cartInvoiceApplySeq) {
          return true;
        }
        setCartReady(root, true);
        updateCartSnapshotOnRoot(root, fields);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        showFeedback(root, '', false);
        return true;
      })
      .catch(function (error) {
        if (applySeq !== cartInvoiceApplySeq) {
          return false;
        }
        var message = i18n.save_error || '';
        if (error && error.message && error.message !== 'Cart update failed') {
          message = error.message;
        }
        showFeedback(root, message, false);
        return false;
      });
  }

  function getPageVisitId() {
    if (!window.__cartInvoiceVisitId) {
      window.__cartInvoiceVisitId = String(performance && performance.timeOrigin ? performance.timeOrigin : Date.now());
    }
    return window.__cartInvoiceVisitId;
  }

  function persistUserChoice(root) {
    if (!root) {
      return;
    }
    var selectedId = root.getAttribute('data-cart-invoice-selected-id') || '';
    if (!selectedId) {
      return;
    }
    try {
      sessionStorage.setItem(
        'cart-invoice-choice',
        JSON.stringify({
          visitId: getPageVisitId(),
          selectedId: selectedId,
        })
      );
    } catch (storageError) {}
  }

  function restoreUserChoiceToRoot(root) {
    if (!root) {
      return;
    }
    try {
      var raw = sessionStorage.getItem('cart-invoice-choice');
      if (!raw) {
        return;
      }
      var data = JSON.parse(raw);
      if (!data || data.visitId !== getPageVisitId() || !data.selectedId) {
        sessionStorage.removeItem('cart-invoice-choice');
        return;
      }
      root.dataset.cartInvoiceUserPicked = 'true';
      root.setAttribute('data-cart-invoice-selected-id', String(data.selectedId));
    } catch (storageError) {
      sessionStorage.removeItem('cart-invoice-choice');
    }
  }

  function clearPersistedUserChoice() {
    try {
      sessionStorage.removeItem('cart-invoice-choice');
    } catch (storageError) {}
  }

  function storefrontBillingProfilesUrl(apiBase) {
    return apiBase + '/api/storefront/billing-profiles';
  }

  function storefrontCustomerQuery(root) {
    return {
      shop: getShop(root),
      customerId: root.getAttribute('data-cart-invoice-customer-id') || '',
    };
  }

  function fetchLegacyCorporateInvoiceProfile(apiBase, shop, customerId) {
    var legacyUrl =
      apiBase +
      '/api/storefront/corporate-invoice-profile?shop=' +
      encodeURIComponent(shop) +
      '&customerId=' +
      encodeURIComponent(customerId);
    return fetch(legacyUrl, { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .catch(function () {
        return null;
      });
  }

  function fetchStorefrontBillingProfiles(root) {
    var apiBase = getApiBase(root);
    var query = storefrontCustomerQuery(root);
    if (!apiBase || !query.shop || !query.customerId) {
      return Promise.resolve(null);
    }
    var listUrl =
      storefrontBillingProfilesUrl(apiBase) +
      '?shop=' +
      encodeURIComponent(query.shop) +
      '&customerId=' +
      encodeURIComponent(query.customerId);
    return fetch(listUrl, { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json().then(function (json) {
          if (response.ok && json && json.ok) {
            return json;
          }
          return fetchLegacyCorporateInvoiceProfile(apiBase, query.shop, query.customerId);
        });
      })
      .catch(function () {
        return fetchLegacyCorporateInvoiceProfile(apiBase, query.shop, query.customerId);
      });
  }

  function buildRemoteProfileBody(root, fields, editId) {
    var body = {
      shop: getShop(root),
      customerId: root.getAttribute('data-cart-invoice-customer-id') || '',
      addressTitle: fields.addressTitle,
      province: fields.province,
      district: fields.district,
      neighborhood: fields.neighborhood,
      addressLine: fields.addressLine,
      entityType: fields.entityType,
      companyName: fields.companyName,
      fullName: fields.fullName,
      vkn: fields.vkn,
      tckn: fields.tckn,
      taxOffice: fields.taxOffice,
    };
    if (editId) {
      body.id = editId;
    }
    return body;
  }

  function remoteProfileSaveSucceeded(payload) {
    return Boolean(payload && payload.ok);
  }

  function savedProfileIdFromPayload(payload, fallbackId) {
    if (!payload) {
      return fallbackId || '';
    }
    if (payload.profile && payload.profile.id != null) {
      return String(payload.profile.id);
    }
    if (payload.id != null) {
      return String(payload.id);
    }
    return fallbackId || '';
  }

  function persistBillingProfileRemote(root, fields, editId) {
    var apiBase = getApiBase(root);
    if (!apiBase) {
      return Promise.resolve(null);
    }
    var body = buildRemoteProfileBody(root, fields, editId);
    var method = editId ? 'PUT' : 'POST';
    return fetch(storefrontBillingProfilesUrl(apiBase), {
      method: method,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
      .then(function (response) {
        return response.json().then(function (json) {
          if (!json || typeof json !== 'object') {
            return { ok: false };
          }
          if (!response.ok && json.ok !== true) {
            json.ok = false;
          }
          return json;
        });
      })
      .catch(function () {
        return { ok: false };
      });
  }

  function setProfilesFetchState(root, loading) {
    if (!root) {
      return;
    }
    root.setAttribute('data-cart-invoice-profiles-loading', loading ? 'true' : 'false');
  }

  function isProfilesLoading(root) {
    return root.getAttribute('data-cart-invoice-profiles-loading') === 'true';
  }

  function validateInvoiceCheckout(root) {
    var i18n = getI18n();
    var toggle = root.querySelector('[data-cart-invoice-enabled]');
    if (!toggle || !toggle.checked) {
      return { ok: true, message: '' };
    }
    if (!isLoggedIn(root)) {
      return { ok: false, message: i18n.guest_checkout || i18n.checkout_blocked || '' };
    }
    if (isProfilesLoading(root)) {
      return { ok: false, message: i18n.checkout_blocked || '' };
    }
    if (!isCartReady(root)) {
      return { ok: false, message: i18n.select_profile || i18n.checkout_blocked || '' };
    }
    var profileList = root.querySelector('[data-cart-invoice-profile-list]');
    var hasProfiles = Boolean(profileList && profileList._profiles && profileList._profiles.length);
    var selectedId = root.getAttribute('data-cart-invoice-selected-id') || '';
    if (hasProfiles && !selectedId) {
      return { ok: false, message: i18n.select_profile || i18n.checkout_blocked || '' };
    }
    return { ok: true, message: '' };
  }

  function fetchGeo(apiBase, type, params) {
    var query = 'type=' + encodeURIComponent(type);
    if (params && params.il) {
      query += '&il=' + encodeURIComponent(params.il);
    }
    if (params && params.ilce) {
      query += '&ilce=' + encodeURIComponent(params.ilce);
    }
    return fetch(apiBase + '/api/geo?' + query, { headers: { Accept: 'application/json' } }).then(function (response) {
      return response.json().then(function (json) {
        if (!response.ok || !json.ok) {
          throw new Error('Geo failed');
        }
        return json.items || [];
      });
    });
  }

  function fillSelect(select, placeholder, items, selectedValue) {
    if (!select) {
      return;
    }
    select.innerHTML = '';
    var emptyOption = document.createElement('option');
    emptyOption.value = '';
    emptyOption.textContent = placeholder;
    select.appendChild(emptyOption);
    var i = 0;
    for (i = 0; i < items.length; i += 1) {
      var item = items[i];
      var option = document.createElement('option');
      option.value = item;
      option.textContent = item;
      if (selectedValue && selectedValue === item) {
        option.selected = true;
      }
      select.appendChild(option);
    }
    select.disabled = items.length === 0;
  }

  function geoSelectPlaceholder(modal, key) {
    var select = modal.querySelector('[data-cart-invoice-' + key + ']');
    if (!select) {
      return '';
    }
    var emptyOption = select.querySelector('option[value=""]');
    return emptyOption ? emptyOption.textContent : '';
  }

  function resetModalGeoSelects(modal) {
    var provinceSelect = modal.querySelector('[data-cart-invoice-province]');
    var districtSelect = modal.querySelector('[data-cart-invoice-district]');
    var neighborhoodSelect = modal.querySelector('[data-cart-invoice-neighborhood]');
    var provincePh = geoSelectPlaceholder(modal, 'province');
    var districtPh = geoSelectPlaceholder(modal, 'district');
    var neighborhoodPh = geoSelectPlaceholder(modal, 'neighborhood');
    if (provinceSelect && provincePh) {
      fillSelect(provinceSelect, provincePh, [], '');
    }
    if (districtSelect && districtPh) {
      fillSelect(districtSelect, districtPh, [], '');
      districtSelect.disabled = true;
    }
    if (neighborhoodSelect && neighborhoodPh) {
      fillSelect(neighborhoodSelect, neighborhoodPh, [], '');
      neighborhoodSelect.disabled = true;
    }
  }

  function loadProvinces(root, modal, selectedProvince) {
    var apiBase = getApiBase(root);
    var provinceSelect = modal.querySelector('[data-cart-invoice-province]');
    if (!apiBase || !provinceSelect) {
      return Promise.resolve();
    }
    var current = selectedProvince != null ? selectedProvince : fieldValue(modal, 'province');
    var placeholder = geoSelectPlaceholder(modal, 'province');
    return fetchGeo(apiBase, 'iller', {})
      .then(function (items) {
        fillSelect(provinceSelect, placeholder, items, current || '');
        if (current) {
          return undefined;
        }
        var districtSelect = modal.querySelector('[data-cart-invoice-district]');
        var neighborhoodSelect = modal.querySelector('[data-cart-invoice-neighborhood]');
        if (districtSelect) {
          fillSelect(districtSelect, geoSelectPlaceholder(modal, 'district'), [], '');
          districtSelect.disabled = true;
        }
        if (neighborhoodSelect) {
          fillSelect(neighborhoodSelect, geoSelectPlaceholder(modal, 'neighborhood'), [], '');
          neighborhoodSelect.disabled = true;
        }
        return undefined;
      })
      .catch(function () {});
  }

  function loadDistricts(root, modal, province, selectedDistrict, selectedNeighborhood) {
    var apiBase = getApiBase(root);
    var districtSelect = modal.querySelector('[data-cart-invoice-district]');
    var neighborhoodSelect = modal.querySelector('[data-cart-invoice-neighborhood]');
    if (!apiBase || !districtSelect || !province) {
      return Promise.resolve();
    }
    var districtPlaceholder = districtSelect.querySelector('option') ? districtSelect.querySelector('option').textContent : '';
    fillSelect(neighborhoodSelect, neighborhoodSelect && neighborhoodSelect.querySelector('option') ? neighborhoodSelect.querySelector('option').textContent : '', [], '');
    if (neighborhoodSelect) {
      neighborhoodSelect.disabled = true;
    }
    return fetchGeo(apiBase, 'ilceler', { il: province })
      .then(function (items) {
        fillSelect(districtSelect, districtPlaceholder, items, selectedDistrict || '');
        districtSelect.disabled = false;
        if (selectedDistrict) {
          return loadNeighborhoods(root, modal, province, selectedDistrict, selectedNeighborhood);
        }
        return undefined;
      })
      .catch(function () {
        districtSelect.disabled = true;
      });
  }

  function loadNeighborhoods(root, modal, province, district, selectedNeighborhood) {
    var apiBase = getApiBase(root);
    var neighborhoodSelect = modal.querySelector('[data-cart-invoice-neighborhood]');
    if (!apiBase || !neighborhoodSelect || !province || !district) {
      return Promise.resolve();
    }
    var placeholder = neighborhoodSelect.querySelector('option') ? neighborhoodSelect.querySelector('option').textContent : '';
    return fetchGeo(apiBase, 'mahalleler', { il: province, ilce: district })
      .then(function (items) {
        fillSelect(neighborhoodSelect, placeholder, items, selectedNeighborhood || '');
        neighborhoodSelect.disabled = false;
      })
      .catch(function () {
        neighborhoodSelect.disabled = true;
      });
  }

  function fillModalFromFields(modal, fields) {
    resetModalGeoSelects(modal);
    setEntityType(modal, fields.entityType);
    setFieldValue(modal, 'addressTitle', fields.addressTitle);
    setFieldValue(modal, 'taxOffice', fields.taxOffice);
    setFieldValue(modal, 'addressLine', fields.addressLine);
    setFieldValue(modal, 'companyName', fields.companyName);
    setFieldValue(modal, 'fullName', fields.fullName);
    setFieldValue(modal, 'vkn', fields.vkn);
    setFieldValue(modal, 'tckn', fields.tckn);
  }

  function openModal(root, mode, profile) {
    if (!isLoggedIn(root)) {
      redirectToLogin(root);
      return;
    }
    var modal = getModal(root);
    var i18n = getI18n();
    if (!modal) {
      return;
    }
    clearFieldErrors(modal);
    showModalFeedback(modal, '');
    var titleEl = modal.querySelector('[data-cart-invoice-modal-title]');
    if (titleEl) {
      titleEl.textContent = mode === 'edit' ? i18n.modal_title_edit || '' : i18n.modal_title_add || '';
    }
    modal.dataset.cartInvoiceModalMode = mode;
    modal.dataset.cartInvoiceEditingId = '';
    if (profile) {
      var profileListEl = root.querySelector('[data-cart-invoice-profile-list]');
      var modalProfiles = profileListEl && profileListEl._profiles ? profileListEl._profiles : [];
      var profileIdx = 0;
      for (profileIdx = 0; profileIdx < modalProfiles.length; profileIdx += 1) {
        if (modalProfiles[profileIdx] === profile) {
          break;
        }
      }
      modal.dataset.cartInvoiceEditingId = profileListId(profile, profileIdx);
    }

    var modalFields = profile
      ? profileToFields(profile)
      : {
          entityType: 'INDIVIDUAL',
          addressTitle: '',
          province: '',
          district: '',
          neighborhood: '',
          addressLine: '',
          taxOffice: '',
          companyName: '',
          fullName: '',
          vkn: '',
          tckn: '',
        };
    fillModalFromFields(modal, modalFields);

    loadProvinces(root, modal, modalFields.province || '').then(function () {
      if (modalFields.province) {
        return loadDistricts(
          root,
          modal,
          modalFields.province,
          modalFields.district || '',
          modalFields.neighborhood || ''
        );
      }
      return undefined;
    });

    modal.classList.remove('is-active');
    modal.removeAttribute('hidden');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cart-invoice-modal-open');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        modal.classList.add('is-active');
      });
    });
  }

  function finalizeModalClose(modal) {
    modal.classList.remove('is-active');
    modal.setAttribute('hidden', '');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cart-invoice-modal-open');
  }

  function closeModal(root) {
    var modal = getModal(root);
    if (!modal || modal.hasAttribute('hidden')) {
      return;
    }
    if (!modal.classList.contains('is-active')) {
      finalizeModalClose(modal);
      return;
    }
    modal.classList.remove('is-active');
    var closed = false;
    var finish = function () {
      if (closed) {
        return;
      }
      closed = true;
      modal.removeEventListener('transitionend', onTransitionEnd);
      finalizeModalClose(modal);
    };
    var onTransitionEnd = function (event) {
      if (event.target !== modal) {
        return;
      }
      finish();
    };
    modal.addEventListener('transitionend', onTransitionEnd);
    setTimeout(finish, 280);
  }

  function escapeHtml(text) {
    return String(text || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function profileCardMeta(profile, i18n) {
    var typeLabel =
      profile.entityType === 'INDIVIDUAL' ? i18n.entity_individual_short || '' : i18n.entity_company_short || '';
    var name =
      profile.entityType === 'INDIVIDUAL' ? profile.fullName || '' : profile.companyName || '';
    var tax = profile.entityType === 'INDIVIDUAL' ? profile.tckn || '' : profile.vkn || '';
    var parts = [];
    if (typeLabel) {
      parts.push(typeLabel);
    }
    if (name) {
      parts.push(name);
    }
    if (tax) {
      parts.push(tax);
    }
    return parts.join(' · ');
  }

  function setSelectedCard(root, profileId) {
    var activeId = profileId ? String(profileId) : '';
    root.setAttribute('data-cart-invoice-selected-id', activeId);
    root.querySelectorAll('[data-cart-invoice-card]').forEach(function (card) {
      var id = card.getAttribute('data-cart-invoice-card') || '';
      var selected = Boolean(activeId && id === activeId);
      card.classList.toggle('is-selected', selected);
      card.setAttribute('aria-checked', selected ? 'true' : 'false');
      var radio = card.querySelector('[data-cart-invoice-radio]');
      if (radio) {
        radio.checked = selected;
      }
    });
  }

  function markUserProfileChoice(root) {
    if (!root) {
      return;
    }
    root.dataset.cartInvoiceUserPicked = 'true';
    persistUserChoice(root);
  }

  function clearUserProfileChoice(root) {
    if (!root) {
      return;
    }
    delete root.dataset.cartInvoiceUserPicked;
    root.removeAttribute('data-cart-invoice-selected-id');
    clearPersistedUserChoice();
    setSelectedCard(root, '');
  }

  function handleNoSavedProfiles(root) {
    if (root.dataset.cartInvoiceUserPicked === 'true') {
      return;
    }
    setSelectedCard(root, '');
    setCartReady(root, false);
  }

  function syncSelectionAfterRender(root, profiles) {
    if (root.dataset.cartInvoiceUserPicked !== 'true') {
      setSelectedCard(root, '');
      return;
    }
    var existingId = root.getAttribute('data-cart-invoice-selected-id') || '';
    if (existingId && existingId !== 'custom' && findProfile(root, existingId)) {
      setSelectedCard(root, existingId);
      return;
    }
    setSelectedCard(root, '');
  }

  function profileListId(profile, index) {
    return String(profile.id != null ? profile.id : index);
  }

  function selectDefaultProfileIfNeeded(root, profiles) {
    if (!profiles.length) {
      return;
    }
    if (root.dataset.cartInvoiceUserPicked === 'true') {
      return;
    }
    var profile = profiles[0];
    var id = profileListId(profile, 0);
    setSelectedCard(root, id);
    selectProfile(root, profile);
  }

  function updateCartSnapshotOnRoot(root, fields) {
    if (!root || !fields) {
      return;
    }
    var tax = fields.entityType === 'COMPANY' ? fields.vkn : fields.tckn;
    var company = fields.entityType === 'COMPANY' ? fields.companyName : fields.fullName;
    root.setAttribute('data-cart-invoice-cart-tax', digitsOnly(tax));
    root.setAttribute('data-cart-invoice-cart-company', company || '');
  }

  function renderProfiles(root, profiles) {
    var list = root.querySelector('[data-cart-invoice-profile-list]');
    var emptyEl = root.querySelector('[data-cart-invoice-empty]');
    var customerId = root.getAttribute('data-cart-invoice-customer-id') || '';
    if (!list) {
      return;
    }
    list._profiles = profiles;
    if (!profiles.length) {
      list.innerHTML = '';
      if (emptyEl) {
        emptyEl.hidden = false;
      }
      handleNoSavedProfiles(root);
      return;
    }
    if (emptyEl) {
      emptyEl.hidden = true;
    }
    var i18n = getI18n();
    var radioName = root.getAttribute('data-cart-invoice-radio-name') || 'cart-invoice-profile';
    var html = '';
    var i = 0;
    for (i = 0; i < profiles.length; i += 1) {
      var profile = profiles[i];
      var id = profileListId(profile, i);
      var title = profile.addressTitle || profileCardMeta(profile, i18n);
      var meta = profile.addressTitle ? profileCardMeta(profile, i18n) : profile.taxOffice || '';
      html += '<article class="cart-invoice__card" data-cart-invoice-card="' + escapeHtml(id) + '" role="radio" aria-checked="false" tabindex="0">';
      html += '<label class="cart-invoice__card-label">';
      html += '<input type="radio" class="cart-invoice__radio" data-cart-invoice-radio name="' + escapeHtml(radioName) + '" value="' + escapeHtml(id) + '">';
      html += '<span class="cart-invoice__radio-ui" aria-hidden="true"></span>';
      html += '<span class="cart-invoice__card-content">';
      html += '<span class="cart-invoice__card-title">' + escapeHtml(title) + '</span>';
      if (meta) {
        html += '<span class="cart-invoice__card-meta">' + escapeHtml(meta) + '</span>';
      }
      html += '</span>';
      html += '</label>';
      html += '<button type="button" class="cart-invoice__card-edit" data-cart-invoice-edit="' + escapeHtml(id) + '">';
      html += escapeHtml(i18n.edit || '');
      html += '</button>';
      html += '</article>';
    }
    list.innerHTML = html;
    syncSelectionAfterRender(root, profiles);
    selectDefaultProfileIfNeeded(root, profiles);
  }

  function findProfile(root, id) {
    var list = root.querySelector('[data-cart-invoice-profile-list]');
    var profiles = list && list._profiles ? list._profiles : [];
    var i = 0;
    for (i = 0; i < profiles.length; i += 1) {
      var profile = profiles[i];
      var profileId = profileListId(profile, i);
      if (profileId === String(id)) {
        return profile;
      }
    }
    return null;
  }

  function selectProfile(root, profile) {
    var i18n = getI18n();
    var fields = profileToFields(profile);
    var list = root.querySelector('[data-cart-invoice-profile-list]');
    var allProfiles = list && list._profiles ? list._profiles : [];
    var idx = 0;
    for (idx = 0; idx < allProfiles.length; idx += 1) {
      if (allProfiles[idx] === profile) {
        break;
      }
    }
    var id = profileListId(profile, idx);
    setSelectedCard(root, id);
    return applyFieldsToCart(root, fields, i18n);
  }

  function normalizeProfiles(payload) {
    if (payload && Array.isArray(payload.profiles) && payload.profiles.length) {
      return payload.profiles;
    }
    if (payload && payload.profile && payload.profile.enabled) {
      return [
        {
          id: 'legacy',
          addressTitle: '',
          province: '',
          district: '',
          neighborhood: '',
          addressLine: payload.profile.address || '',
          entityType: 'COMPANY',
          companyName: payload.profile.companyTitle || '',
          vkn: payload.profile.taxNumber || '',
          fullName: null,
          tckn: null,
          taxOffice: payload.profile.taxOffice || '',
        },
      ];
    }
    return [];
  }

  function setProfilesLoading(root, loading) {
    var loader = root.querySelector('[data-cart-invoice-profiles-loading]');
    var content = root.querySelector('[data-cart-invoice-profiles-content]');
    if (!loader || !content) {
      return;
    }
    if (loading) {
      loader.hidden = false;
      content.hidden = true;
      return;
    }
    loader.hidden = true;
    content.hidden = false;
  }

  function loadBillingProfiles(root) {
    var customerId = root.getAttribute('data-cart-invoice-customer-id') || '';
    var shop = getShop(root);
    if (!getApiBase(root) || !customerId || !shop) {
      setProfilesFetchState(root, false);
      return Promise.resolve([]);
    }
    setProfilesFetchState(root, true);
    setProfilesLoading(root, true);
    return fetchStorefrontBillingProfiles(root)
      .then(function (payload) {
        if (!payload || !payload.ok) {
          renderProfiles(root, []);
          return [];
        }
        var profiles = normalizeProfiles(payload);
        renderProfiles(root, profiles);
        return profiles;
      })
      .catch(function () {
        renderProfiles(root, []);
        return [];
      })
      .then(function (profiles) {
        setProfilesLoading(root, false);
        setProfilesFetchState(root, false);
        return profiles;
      });
  }

  function bindRoot(root) {
    if (!root || root.dataset.cartInvoiceBound === 'true') {
      return;
    }
    root.dataset.cartInvoiceBound = 'true';
    restoreUserChoiceToRoot(root);
    var toggle = root.querySelector('[data-cart-invoice-enabled]');
    if (toggle && toggle.checked) {
      if (isLoggedIn(root)) {
        loadBillingProfiles(root);
      } else {
        setCartReady(root, false);
      }
    }
  }

  function initAll() {
    document.querySelectorAll('[data-cart-corporate-invoice]').forEach(function (root) {
      if (root.dataset.cartInvoiceBound !== 'true') {
        bindRoot(root);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('cart:page-section-updated', initAll);

  document.addEventListener('change', function (event) {
    var invoiceRoot = event.target.closest('[data-cart-corporate-invoice]');
    if (invoiceRoot && event.target.matches('[data-cart-invoice-radio]')) {
      var radioId = event.target.value;
      markUserProfileChoice(invoiceRoot);
      setSelectedCard(invoiceRoot, radioId);
      var radioProfile = findProfile(invoiceRoot, radioId);
      if (radioProfile) {
        selectProfile(invoiceRoot, radioProfile);
      }
      return;
    }
    if (invoiceRoot && event.target.matches('[data-cart-invoice-enabled]')) {
      var toggleI18n = getI18n();
      var body = invoiceRoot.querySelector('[data-cart-invoice-body]');
      if (event.target.checked) {
        if (body) {
          body.removeAttribute('hidden');
        }
        clearUserProfileChoice(invoiceRoot);
        if (isLoggedIn(invoiceRoot)) {
          loadBillingProfiles(invoiceRoot);
        } else {
          setCartReady(invoiceRoot, false);
        }
      } else {
        if (body) {
          body.setAttribute('hidden', '');
        }
        closeModal(invoiceRoot);
        clearCorporateInvoice(invoiceRoot, toggleI18n);
      }
      return;
    }
    var modal = event.target.closest('[data-cart-invoice-modal]');
    if (!modal) {
      return;
    }
    var root = modal.closest('[data-cart-corporate-invoice]');
    if (!root) {
      return;
    }
    if (event.target.matches('[data-cart-invoice-province]')) {
      loadDistricts(root, modal, fieldValue(modal, 'province'), '', '');
    }
    if (event.target.matches('[data-cart-invoice-district]')) {
      loadNeighborhoods(root, modal, fieldValue(modal, 'province'), fieldValue(modal, 'district'), '');
    }
    if (event.target.matches('[data-cart-invoice-entity-select]')) {
      setEntityType(modal, event.target.value);
    }
  });

  document.addEventListener('click', function (event) {
    var root = event.target.closest('[data-cart-corporate-invoice]');
    if (root) {
      if (event.target.closest('[data-cart-invoice-add]')) {
        event.preventDefault();
        openModal(root, 'add', null);
        return;
      }

      var editBtn = event.target.closest('[data-cart-invoice-edit]');
      if (editBtn) {
        event.preventDefault();
        var editId = editBtn.getAttribute('data-cart-invoice-edit');
        var editProfile = findProfile(root, editId);
        if (editProfile) {
          openModal(root, 'edit', editProfile);
        }
        return;
      }

      if (event.target.closest('[data-cart-invoice-modal-close]')) {
        event.preventDefault();
        closeModal(root);
        return;
      }

      if (event.target.closest('[data-cart-invoice-modal-save]')) {
        event.preventDefault();
        var modal = getModal(root);
        var i18n = getI18n();
        if (!modal || !validateForm(modal, i18n)) {
          return;
        }
        var fields = collectForm(modal);
        var editId = modal.dataset.cartInvoiceEditingId || '';
        setModalSavePending(modal, true, i18n);
        applyFieldsToCart(root, fields, i18n).then(function (ok) {
          if (!ok) {
            setModalSavePending(modal, false, i18n);
            showModalFeedback(modal, i18n.save_error || '', false);
            return;
          }
          persistBillingProfileRemote(root, fields, editId).then(function (payload) {
            if (!remoteProfileSaveSucceeded(payload)) {
              setModalSavePending(modal, false, i18n);
              var profileError = payload && payload.error ? String(payload.error) : i18n.save_error || '';
              showModalFeedback(modal, profileError, false);
              return;
            }
            loadBillingProfiles(root).then(function () {
              var selectId = savedProfileIdFromPayload(payload, editId);
              if (selectId) {
                setSelectedCard(root, selectId);
                markUserProfileChoice(root);
              }
              setModalSavePending(modal, false, i18n);
              showModalFeedback(modal, '', false);
              closeModal(root);
            });
          });
        });
        return;
      }
    }

    var checkoutLink = event.target.closest('.cart-page__checkout');
    if (!checkoutLink) {
      return;
    }
    var invoiceRoot = document.querySelector('[data-cart-corporate-invoice]');
    if (!invoiceRoot) {
      return;
    }
    var checkoutState = validateInvoiceCheckout(invoiceRoot);
    if (!checkoutState.ok) {
      event.preventDefault();
      showFeedback(invoiceRoot, checkoutState.message, false);
    }
  });
})();
